// hooks/useModals.js
import { useState } from 'react';

export const useModals = () => {
  // Edit note modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState(null);

  // New task modal
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [editingTask, setEditingTask] = useState(null);

  // New note modal
  const [showNewModal, setShowNewModal] = useState(false);
  const [prefilledData, setPrefilledData] = useState(null);
  const [modalSource, setModalSource] = useState("dashboard");

  // Attached file modal
  const [showAttachedFileModal, setShowAttachedFileModal] = useState(false);
  const [selectedFileNote, setSelectedFileNote] = useState(null);

  // View note modal
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewNote, setViewNote] = useState(null);

  // Close helpers
  const closeEditModal = () => {
    setShowEditModal(false);
    setSelectedNote(null);
  };

  const closeNewTaskModal = () => {
    setShowNewTaskModal(false);
    setEditingTask(null);
  };

  const closeNewModal = () => {
    setShowNewModal(false);
    setPrefilledData(null);
  };

  const closeAttachedFileModal = () => {
    setShowAttachedFileModal(false);
    setSelectedFileNote(null);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewNote(null);
  };

  return {
    // Edit modal
    showEditModal,
    setShowEditModal,
    selectedNote,
    setSelectedNote,
    closeEditModal,
    // New task modal
    showNewTaskModal,
    setShowNewTaskModal,
    editingTask,
    setEditingTask,
    closeNewTaskModal,
    // New note modal ⬅️ ensure all these are included
    showNewModal,
    setShowNewModal,        // ✅ required
    prefilledData,
    setPrefilledData,
    modalSource,
    setModalSource,
    closeNewModal,
    // Attached file modal
    showAttachedFileModal,
    setShowAttachedFileModal,
    selectedFileNote,
    setSelectedFileNote,
    closeAttachedFileModal,
    // View modal
    showViewModal,
    setShowViewModal,
    viewNote,
    setViewNote,
    closeViewModal,
  };
};